<template>
    <div v-if="!loading">
        <!---->
        <!-- trong positionsAndWaitingTasks đã bao gồm waiting-tasks nên thêm vào sẽ bị thừa khi trong shipping-information merge positions và waiting-tasks -->
        <!-- nếu muốn truyền waiting-tasks vào shipping-information thì positions phải là journey.positions -->
        <shipping-information
            :positions="journey.positionsAndWaitingTasks"
            :condition="journey.condition || order.condition"
            :waiting-tasks="[]"
            :edit-travel-time="cEditable"
            :disabled="!cEditable"
            :index-begin="journey.stageIndexBegin || 0"
            :index-end="journey.stageIndexEnd || 999"
            :task-index-begin="journey.travelIndexStart"
            :task-index-end="journey.travelIndexEnd" />

        <div
            v-if="cEditable"
            class="mb-4">
            <hts-form-button
                color="primary"
                :loading="updating"
                @click="updateJourneyPlanning(false)">
                {{ $t('labels.save') }}
            </hts-form-button>
            <hts-form-button @click="handleCancel">
                {{ $t('labels.cancel') }}
            </hts-form-button>
        </div>

        <hts-modal
            v-model="preAlertVisible"
            size="large"
            title="Xác nhận thông tin">
            <template
                v-for="(alert, index) in preAlertList"
                :key="index">
                <div class="my-1 text-error-500">
                    <alert-task
                        v-if="alert.cls === 'task'"
                        :journey="journey"
                        :item="alert" />
                    <alert-stage
                        v-else-if="alert.cls === 'stage'"
                        :journey="journey"
                        :item="alert" />
                </div>
            </template>
            <hts-form-button
                color="primary"
                :loading="updating"
                @click="updateJourneyPlanning(true)">
                {{ $t('labels.save') }}
            </hts-form-button>
            <hts-form-button @click="preAlertVisible = false">
                {{ $t('labels.cancel') }}
            </hts-form-button>
        </hts-modal>
        <!-- MODAL -->
        <hts-modal
            v-model="scheduleErrorVisible"
            title="Điều chỉnh thông tin vận chuyển">
            <div class="mt-5">
                <p>
                    Đơn hàng đang vi phạm nguyên tắc vận chuyển. Bạn phải điều chỉnh thông tin vận chuyển
                </p>
            </div>

            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-position="right"
                    color="primary"
                    type="button"
                    :outline="false"
                    @click="scheduleErrorVisible = false">
                    Điều chỉnh thời gian
                </hts-form-button>
            </div>
        </hts-modal>
    </div>
</template>
<script lang="ts" setup>
import ShippingInformation from '../../order/ignore/shipping-information.vue'
import AlertStage from './alert-components/alert-stage.vue'
import AlertTask from './alert-components/alert-task.vue'
const props = defineProps({
  journey: {
    type: Object,
    required: true
  },
  order: {
    type: Object,
    required: true
  },
  editable: Boolean
})
const emits = defineEmits(['update:editable', 'change', 'cancel'])
const { journey, order, editable } = toRefs(props)
const scheduleErrorVisible = ref(false)
const cEditable = computed({
  get () {
    return editable.value
  },
  set (val: boolean) {
    emits('update:editable', val)
  }
})
const optimizeWaitingTimeRef = ref()
onMounted(() => {
  setTimeout(() => {
    showOptimize()
  }, 500)
})
onBeforeUnmount(() => {
  optimizeWaitingTimeRef.value?.close()
})

const showOptimize = () => {
  if (order.value) {
    const { stages, shippingPlan, optimalWaitingTime } = journey.value
    const { solution } = order.value

    if (solution !== 'manualPlanning') {
      optimizeWaitingTimeRef.value?.show(stages, shippingPlan?.[shippingPlan?.length - 1], optimalWaitingTime)
    } else {
      optimizeWaitingTimeRef.value?.close()
    }
  }
}

const updating = ref(false)
const preAlertVisible = ref(false)
const preAlertList = ref<any[]>([])
const updateJourneyPlanning = (force: boolean = false) => {
  updating.value = true
  const { waitingTasks, workingTimeRequest } = journey.value
  $api($urlPartner.monitoring.journey.updatePlanning, {
    uriParams: { ID: journey.value.id },
    body: {
      positions: journey.value.positionsAndWaitingTasks,
      waitingTasks,
      workingTimeRequest,
      force: true
    }
  })
    .then((response: any) => {
      const { data, success, errors } = response.data?.value || {}
      const code = data.code

      updating.value = false
      // tăng số lần vi phạm nguyên tắt
      if (code === 201) {
        scheduleErrorVisible.value = true
        return
      }
      if (success) {
        preAlertVisible.value = false
        preAlertList.value = []
        emits('change')
      } else {
        preAlertVisible.value = true
        preAlertList.value = errors || []
      }
    })
    .catch(() => {
      updating.value = false
    })
}

const loading = ref(false)
const refresh = () => {
  loading.value = true
  setTimeout(() => {
    loading.value = false
    setTimeout(() => {
      showOptimize()
    }, 500)
  }, 300)
}
const handleCancel = () => {
  cEditable.value = false
  emits('cancel')
}

defineExpose({ refresh })
</script>
